import React from "react";
import styles from "./Table.module.css";

export const Table = () => {
    return (
        <div className={styles.container}>
            <div className={styles.header}>
                Данные по области <span className={styles.headerStrong}>Чуй</span>
            </div>
            <input
                type="text"
                placeholder="Поиск"
                className={styles.search}
            />
            <div className={styles.tableTitle}>
                Предприятия
            </div>
            <div className={styles.tableRow}>
                ОсОО «Кыргыз Мясопродукт»
            </div>
        </div>
    );
};   